<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="logs"
          multiTemplateDataRows
          class="mat-mdc-table mdc-data-table__table cdk-table table text-nowrap text-md-nowrap table-bordered technical-table"
        >
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef class="expand-header">-</th>
            <td mat-cell *matCellDef="let row" class="expand-cell">
              <button
                mat-icon-button
                type="button"
                class="expand-btn"
                (click)="toggle(row); $event.stopPropagation()"
                [attr.aria-label]="'Expandir linha'"
              >
                <mat-icon class="expand-icon">
                  {{ isExpanded(row) ? "expand_less" : "expand_more" }}
                </mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="dateExecution">
            <th mat-header-cell *matHeaderCellDef>Data</th>
            <td mat-cell *matCellDef="let row">
              {{ row?.dateExecution | date: "dd/MM/yyyy HH:mm:ss" : "GMT" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="idAccount">
            <th mat-header-cell *matHeaderCellDef>Conta</th>
            <td mat-cell *matCellDef="let row">
              {{ row?.idAccount || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="typeOperation">
            <th mat-header-cell *matHeaderCellDef>Operação</th>
            <td mat-cell *matCellDef="let row" class="text-center-cell">
              {{ row?.typeOperation || "-" | titlecase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="bankProvider">
            <th mat-header-cell *matHeaderCellDef>Provedor Bancário</th>
            <td mat-cell *matCellDef="let row" class="text-center-cell">
              {{ row?.bankProvider || "-" | titlecase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="idTransaction">
            <th mat-header-cell *matHeaderCellDef>Transação</th>
            <td mat-cell *matCellDef="let row">
              {{ row?.idTransaction || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let row"
              [attr.colspan]="displayedColumnsWithExpand.length"
              class="expanded-detail-cell"
            >
              <div
                class="expanded-detail"
                [@detailExpand]="isExpanded(row) ? 'expanded' : 'collapsed'"
              >
                <div class="detail-box">
                  <div class="detail-grid">
                    <div class="detail-col">
                      <div class="detail-title">Mensagem De Erro:</div>
                      <pre class="detail-pre">{{ errorPretty(row) }}</pre>
                    </div>

                    <div class="detail-col">
                      <div class="detail-title">Requisição Ao Provedor:</div>
                      <pre class="detail-pre">{{ shippingPretty(row) }}</pre>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <thead role="rowgroup">
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumnsWithExpand"
              class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row"
            ></tr>
          </thead>

          <tbody role="rowgroup" class="mdc-data-table__content">
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: displayedColumnsWithExpand;
                trackBy: trackById
              "
              class="mat-mdc-row mdc-data-table__row cdk-row clickable-row"
              [class.row-expanded]="isExpanded(row)"
              (click)="toggle(row)"
            ></tr>

            <tr
              mat-row
              *matRowDef="let row; columns: ['expandedDetail']"
              class="detail-row mat-mdc-row mdc-data-table__row cdk-row"
              [class.detail-open]="isExpanded(row)"
            ></tr>

            <tr class="border-bottom" *matNoDataRow>
              <td [attr.colspan]="displayedColumnsWithExpand.length">
                {{ "common.noData" | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</form>
